import { render, staticRenderFns } from "./OrganizationPdls.vue?vue&type=template&id=56cd71fe"
import script from "./OrganizationPdls.vue?vue&type=script&lang=js"
export * from "./OrganizationPdls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports